<template>
  <div></div>
</template>

<script>
export default {
  name: "brand",

}
</script>

<style scoped>

</style>